import {
  GET_NEXT_OF_KIN,
  GET_NEXT_OF_KIN_FAILURE,
  GET_NEXT_OF_KIN_SUCCESS,
  SAVE_NEXT_OF_KIN,
  SAVE_NEXT_OF_KIN_FAILURE,
  SAVE_NEXT_OF_KIN_SUCCESS,
  // other
  FETCH_OTHER_CONTACTS,
  FETCH_OTHER_CONTACTS_FAILURE,
  FETCH_OTHER_CONTACTS_SUCCESS,
  ADD_OTHER_CONTACT,
  ADD_OTHER_CONTACT_FAILURE,
  ADD_OTHER_CONTACT_SUCCESS,
  EDIT_OTHER_CONTACT,
  EDIT_OTHER_CONTACT_FAILURE,
  EDIT_OTHER_CONTACT_SUCCESS,
  DELETE_OTHER_CONTACT,
  DELETE_OTHER_CONTACT_FAILURE,
  DELETE_OTHER_CONTACT_SUCCESS,
  TOGGLE_OTHER_KIN_MODAL,
  SEARCH_CONTACTS,
  SEARCH_CONTACTS_FAILURE,
  SEARCH_CONTACTS_SUCCESS,
  GET_CONTACT_SUGGESTIONS,
  GET_CONTACT_SUGGESTIONS_FAILURE,
  GET_CONTACT_SUGGESTIONS_SUCCESS,
} from "./constants";

export const getNextOfKin = (payload, onGet) => ({
  type: GET_NEXT_OF_KIN,
  payload,
  onGet,
});
export const getNextOfKinSuccess = (payload) => ({
  type: GET_NEXT_OF_KIN_SUCCESS,
  payload,
});
export const getNextOfKinFailure = (payload) => ({
  type: GET_NEXT_OF_KIN_FAILURE,
  payload,
});

export const saveNextOfKin = (payload) => ({
  type: SAVE_NEXT_OF_KIN,
  payload,
});
export const saveNextOfKinSuccess = (payload) => ({
  type: SAVE_NEXT_OF_KIN_SUCCESS,
  payload,
});
export const saveNextOfKinFailure = (payload) => ({
  type: SAVE_NEXT_OF_KIN_FAILURE,
  payload,
});

export const fetchOtherContacts = (payload) => ({
  type: FETCH_OTHER_CONTACTS,
  payload,
});
export const fetchOtherContactsSuccess = (payload) => ({
  type: FETCH_OTHER_CONTACTS_SUCCESS,
  payload,
});
export const fetchOtherContactsFailure = (payload) => ({
  type: FETCH_OTHER_CONTACTS_FAILURE,
  payload,
});

export const addOtherContact = (payload, onAdd) => ({
  type: ADD_OTHER_CONTACT,
  payload,
  onAdd,
});
export const addOtherContactSuccess = (payload) => ({
  type: ADD_OTHER_CONTACT_SUCCESS,
  payload,
});
export const addOtherContactFailure = (payload) => ({
  type: ADD_OTHER_CONTACT_FAILURE,
  payload,
});

export const editOtherContact = (payload, onEdit) => ({
  type: EDIT_OTHER_CONTACT,
  payload,
  onEdit,
});
export const editOtherContactSuccess = (payload) => ({
  type: EDIT_OTHER_CONTACT_SUCCESS,
  payload,
});
export const editOtherContactFailure = (payload) => ({
  type: EDIT_OTHER_CONTACT_FAILURE,
  payload,
});

export const deleteOtherContact = (payload, onDelete) => ({
  type: DELETE_OTHER_CONTACT,
  payload,
  onDelete,
});
export const deleteOtherContactSuccess = (payload) => ({
  type: DELETE_OTHER_CONTACT_SUCCESS,
  payload,
});
export const deleteOtherContactFailure = (payload) => ({
  type: DELETE_OTHER_CONTACT_FAILURE,
  payload,
});

export const toggleOtherKinModal = (payload) => ({
  type: TOGGLE_OTHER_KIN_MODAL,
  payload,
});

export const searchContacts = (payload) => ({
  type: SEARCH_CONTACTS,
  payload,
});
export const searchContactsSuccess = (payload) => ({
  type: SEARCH_CONTACTS_SUCCESS,
  payload,
});
export const searchContactsFailure = (payload) => ({
  type: SEARCH_CONTACTS_FAILURE,
  payload,
});

export const getContactSuggestions = (payload) => ({
  type: GET_CONTACT_SUGGESTIONS,
  payload,
});
export const getContactSuggestionsSuccess = (payload) => ({
  type: GET_CONTACT_SUGGESTIONS_SUCCESS,
  payload,
});
export const getContactSuggestionsFailure = (payload) => ({
  type: GET_CONTACT_SUGGESTIONS_FAILURE,
  payload,
});
